import { Observable } from 'rxjs';

import { Toast, ToastType } from '../models/toast.model';

export abstract class ToastUsecase {
  abstract get toasts$(): Observable<Toast[]>;

  abstract show(message: string, type: ToastType, delay?: number): void;
}
